import {ErrorBoundary} from "@sentry/react";
import {Helmet} from "react-helmet-async";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UptimeWidgetContent} from "@/pages/tools/UptimeWidgetContent.tsx";

export const UptimeWidget = () => {
  return (
    <ContentContainer title="Uptime Widget">
      <Helmet>
        <title>Uptime Widget</title>
      </Helmet>
      <ErrorBoundary>
        <UptimeWidgetContent />
      </ErrorBoundary>
    </ContentContainer>
  );
};
